import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import InProgressDot from '../../../components/ContentCards/ReducedContentCard/subcomponents/InProgressDot';
import PositionedInlineList from '../../../components/ContentCards/ReducedContentCard/subcomponents/PositionedInlineList';
import CompletedIcon from '../../../components/ContentCards/ReducedContentCard/subcomponents/CompletedIcon';
import ReducedCardLayout from '../../../components/ContentCards/ReducedContentCard/subcomponents/ReducedCardLayout';
import { FILTER_CONSTS } from '../../../constants/TopFilterConstants';
import UsageTracker from '../../../utils/UsageTracker';
import { useCallback, useMemo } from 'react';
import ReducedCardSkeleton from '../../../components/ContentCards/ReducedContentCard/subcomponents/ReducedCardSkeleton';
import { useFullPlaylist, usePlaylistRemainingItemsAndProgress } from '..';
import { getPlaylistUrl } from '../../../utils/RoutingUtils';
import { CardMenuIcon, ReducedCardMenuIconBox } from '../../cardMenu';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ReducedPlaylistCard = ({
  playlistId,
  expandableContent,
  onClick = () => {},
  use,
  appearsIn,
  position,
  verticalGap,
  isSelected,
  size,
  customAction
}) => {
  const {
    playlist,
    playlistLoading
  } = useFullPlaylist(playlistId);
  const {
    status,
    remainingProgressItemCount,
    progressAmount,
    totalProgressItemCount,
    playlistProgressLoading
  } = usePlaylistRemainingItemsAndProgress(playlistId);
  const to = useMemo(() => {
    if (!playlist) return '';
    return {
      pathname: getPlaylistUrl(playlist.id)
    };
  }, [playlist]);
  const handleClick = useCallback(() => {
    onClick();
    UsageTracker.track('interaction', {
      action: 'content-card-click',
      contentType: 'PLAYLIST',
      playlistId: playlist && playlist.id,
      appearsIn,
      position,
      name: playlist && playlist.name,
      style: 'reduced',
      isInProgress: status === FILTER_CONSTS.STATUSES.IN_PROGRESS
    });
  }, [onClick, playlist, appearsIn, position, status]);
  if (playlistLoading || playlistProgressLoading) {
    return /*#__PURE__*/_jsx(ReducedCardSkeleton, {
      size: size,
      use: use
    });
  }
  if (!playlist) {
    return null;
  }
  return /*#__PURE__*/_jsx(ReducedCardLayout, {
    contentId: playlist.id,
    customAction: customAction,
    description: playlist.description,
    expandableContent: expandableContent,
    isCompleted: status === FILTER_CONSTS.STATUSES.COMPLETED,
    isSelected: isSelected,
    name: playlist.name,
    onClick: handleClick,
    progressAmount: progressAmount,
    rightAction: /*#__PURE__*/_jsx(ReducedCardMenuIconBox, {
      className: "m-right-3",
      children: /*#__PURE__*/_jsx(CardMenuIcon, {
        playlistId: playlistId,
        use: use
      })
    }),
    size: size,
    thumbnailUrl: playlist.thumbnailSquareUrl,
    to: to,
    use: use,
    verticalGap: verticalGap,
    children: status === FILTER_CONSTS.STATUSES.COMPLETED ? /*#__PURE__*/_jsx(PositionedInlineList, {
      children: /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(CompletedIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyComponents.reducedContentCards.completed"
        })]
      })
    }) : /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(InProgressDot, {}), /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "academyComponents.reducedContentCards.numItemsRemaining",
        options: {
          remainingNumber: remainingProgressItemCount,
          totalNumber: totalProgressItemCount
        }
      })]
    })
  });
};